<div class="card-base">
    <div class="card-content-operation">
        <div class="card-container mat-elevation-z1">
            <div class="card-content">
                <div class="archivo-contenedor">
                    <div *ngIf="!files || files.length === 0">
                        <h3>No se encontraron archivos </h3>
                    </div>
                    <div *ngFor="let file of files">
                        <div (click)="download(file)" class="archivo-item">
                            {{ file.Nombre }}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>